import axios from 'axios';
import { injectable } from 'inversify';
import momnent from 'moment';
@injectable()
export class ActaService {
  constructor () { }

  async getPostJournalRecords (tenantId: string, fromDate: momnent.Moment, toDate: momnent.Moment, archivePartId: string, success: Function, fail: Function) {
    await axios.get(process.env.VUE_APP_ACTA_API + tenantId + '/PostJournal/GetPostJournal?id=' + tenantId + '&fromDate=' + fromDate.format('MM/DD/YYYY') + '&toDate=' + toDate.format('MM/DD/YYYY') + '&archivePartId=' + archivePartId)
      .then(response => success(response), error => fail(error));
  }

  async sendPostJournalDocument (tenantId: string, request: any, success: Function, fail: Function) {
    await axios.post(process.env.VUE_APP_ACTA_API + tenantId + '/PostJournal/SendPostJournalDocument', request)
      .then(response => success(response), error => fail(error));
  }

  async getTenantNameBySSoId(ssoId: string, success: Function, fail: Function) {
    axios
      .get(process.env.VUE_APP_ACTA_API + ssoId + '/PostJournal/GetTenantNameBySsoId?ssoId=' + ssoId)
      .then(response => success(response), error => fail(error));
  }
  async getPostjournalReport (tenantId:string, request: any, success: Function, fail: Function, browserLanguage:string) {
    await axios.post(process.env.VUE_APP_ACTA_API + tenantId + '/PostJournal/GetPostjournalReport?language=' + browserLanguage, request)
      .then(response => success(response), error => fail(error));
  }

  async getArchiveParts(ssoId: string, success: Function, fail: Function) {
    axios
      .get(process.env.VUE_APP_ACTA_API + ssoId + '/PostJournal/GetArchiveParts?ssoId=' + ssoId)
      .then(response => success(response), error => fail(error));
  }
}
